/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as UsersIndexImport } from './routes/users/index'
import { Route as StatanalyticsIndexImport } from './routes/statanalytics/index'
import { Route as RoomManagementIndexImport } from './routes/room-management/index'
import { Route as InstanceIndexImport } from './routes/instance/index'
import { Route as ErrorIndexImport } from './routes/error/index'
import { Route as AuthGroupsIndexImport } from './routes/auth-groups/index'
import { Route as UsersIdImport } from './routes/users/$id'
import { Route as ServiceConfigConfigNameImport } from './routes/service-config/$configName'
import { Route as RoomManagementNameImport } from './routes/room-management/$name'
import { Route as AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport } from './routes/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
import { Route as RoomConfigRoomConfigNameImport } from './routes/room-config/$room.$configName'
import { Route as AccountsRoomTypeImport } from './routes/accounts/$room.$type'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UsersIndexRoute = UsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRoute,
} as any)

const StatanalyticsIndexRoute = StatanalyticsIndexImport.update({
  id: '/statanalytics/',
  path: '/statanalytics/',
  getParentRoute: () => rootRoute,
} as any)

const RoomManagementIndexRoute = RoomManagementIndexImport.update({
  id: '/room-management/',
  path: '/room-management/',
  getParentRoute: () => rootRoute,
} as any)

const InstanceIndexRoute = InstanceIndexImport.update({
  id: '/instance/',
  path: '/instance/',
  getParentRoute: () => rootRoute,
} as any)

const ErrorIndexRoute = ErrorIndexImport.update({
  id: '/error/',
  path: '/error/',
  getParentRoute: () => rootRoute,
} as any)

const AuthGroupsIndexRoute = AuthGroupsIndexImport.update({
  id: '/auth-groups/',
  path: '/auth-groups/',
  getParentRoute: () => rootRoute,
} as any)

const UsersIdRoute = UsersIdImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRoute,
} as any)

const ServiceConfigConfigNameRoute = ServiceConfigConfigNameImport.update({
  id: '/service-config/$configName',
  path: '/service-config/$configName',
  getParentRoute: () => rootRoute,
} as any)

const RoomManagementNameRoute = RoomManagementNameImport.update({
  id: '/room-management/$name',
  path: '/room-management/$name',
  getParentRoute: () => rootRoute,
} as any)

const AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute =
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport.update({
    id: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName',
    path: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName',
    getParentRoute: () => rootRoute,
  } as any)

const RoomConfigRoomConfigNameRoute = RoomConfigRoomConfigNameImport.update({
  id: '/room-config/$room/$configName',
  path: '/room-config/$room/$configName',
  getParentRoute: () => rootRoute,
} as any)

const AccountsRoomTypeRoute = AccountsRoomTypeImport.update({
  id: '/accounts/$room/$type',
  path: '/accounts/$room/$type',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName': {
      id: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
      path: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
      fullPath: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
      preLoaderRoute: typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport
      parentRoute: typeof rootRoute
    }
    '/room-management/$name': {
      id: '/room-management/$name'
      path: '/room-management/$name'
      fullPath: '/room-management/$name'
      preLoaderRoute: typeof RoomManagementNameImport
      parentRoute: typeof rootRoute
    }
    '/service-config/$configName': {
      id: '/service-config/$configName'
      path: '/service-config/$configName'
      fullPath: '/service-config/$configName'
      preLoaderRoute: typeof ServiceConfigConfigNameImport
      parentRoute: typeof rootRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdImport
      parentRoute: typeof rootRoute
    }
    '/auth-groups/': {
      id: '/auth-groups/'
      path: '/auth-groups'
      fullPath: '/auth-groups'
      preLoaderRoute: typeof AuthGroupsIndexImport
      parentRoute: typeof rootRoute
    }
    '/error/': {
      id: '/error/'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorIndexImport
      parentRoute: typeof rootRoute
    }
    '/instance/': {
      id: '/instance/'
      path: '/instance'
      fullPath: '/instance'
      preLoaderRoute: typeof InstanceIndexImport
      parentRoute: typeof rootRoute
    }
    '/room-management/': {
      id: '/room-management/'
      path: '/room-management'
      fullPath: '/room-management'
      preLoaderRoute: typeof RoomManagementIndexImport
      parentRoute: typeof rootRoute
    }
    '/statanalytics/': {
      id: '/statanalytics/'
      path: '/statanalytics'
      fullPath: '/statanalytics'
      preLoaderRoute: typeof StatanalyticsIndexImport
      parentRoute: typeof rootRoute
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexImport
      parentRoute: typeof rootRoute
    }
    '/accounts/$room/$type': {
      id: '/accounts/$room/$type'
      path: '/accounts/$room/$type'
      fullPath: '/accounts/$room/$type'
      preLoaderRoute: typeof AccountsRoomTypeImport
      parentRoute: typeof rootRoute
    }
    '/room-config/$room/$configName': {
      id: '/room-config/$room/$configName'
      path: '/room-config/$room/$configName'
      fullPath: '/room-config/$room/$configName'
      preLoaderRoute: typeof RoomConfigRoomConfigNameImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$configName': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups': typeof AuthGroupsIndexRoute
  '/error': typeof ErrorIndexRoute
  '/instance': typeof InstanceIndexRoute
  '/room-management': typeof RoomManagementIndexRoute
  '/statanalytics': typeof StatanalyticsIndexRoute
  '/users': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$configName': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$configName': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups': typeof AuthGroupsIndexRoute
  '/error': typeof ErrorIndexRoute
  '/instance': typeof InstanceIndexRoute
  '/room-management': typeof RoomManagementIndexRoute
  '/statanalytics': typeof StatanalyticsIndexRoute
  '/users': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$configName': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$configName': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups/': typeof AuthGroupsIndexRoute
  '/error/': typeof ErrorIndexRoute
  '/instance/': typeof InstanceIndexRoute
  '/room-management/': typeof RoomManagementIndexRoute
  '/statanalytics/': typeof StatanalyticsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$configName': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
    | '/room-management/$name'
    | '/service-config/$configName'
    | '/users/$id'
    | '/auth-groups'
    | '/error'
    | '/instance'
    | '/room-management'
    | '/statanalytics'
    | '/users'
    | '/accounts/$room/$type'
    | '/room-config/$room/$configName'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
    | '/room-management/$name'
    | '/service-config/$configName'
    | '/users/$id'
    | '/auth-groups'
    | '/error'
    | '/instance'
    | '/room-management'
    | '/statanalytics'
    | '/users'
    | '/accounts/$room/$type'
    | '/room-config/$room/$configName'
  id:
    | '__root__'
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName'
    | '/room-management/$name'
    | '/service-config/$configName'
    | '/users/$id'
    | '/auth-groups/'
    | '/error/'
    | '/instance/'
    | '/room-management/'
    | '/statanalytics/'
    | '/users/'
    | '/accounts/$room/$type'
    | '/room-config/$room/$configName'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute: typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  RoomManagementNameRoute: typeof RoomManagementNameRoute
  ServiceConfigConfigNameRoute: typeof ServiceConfigConfigNameRoute
  UsersIdRoute: typeof UsersIdRoute
  AuthGroupsIndexRoute: typeof AuthGroupsIndexRoute
  ErrorIndexRoute: typeof ErrorIndexRoute
  InstanceIndexRoute: typeof InstanceIndexRoute
  RoomManagementIndexRoute: typeof RoomManagementIndexRoute
  StatanalyticsIndexRoute: typeof StatanalyticsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  AccountsRoomTypeRoute: typeof AccountsRoomTypeRoute
  RoomConfigRoomConfigNameRoute: typeof RoomConfigRoomConfigNameRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute:
    AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute,
  RoomManagementNameRoute: RoomManagementNameRoute,
  ServiceConfigConfigNameRoute: ServiceConfigConfigNameRoute,
  UsersIdRoute: UsersIdRoute,
  AuthGroupsIndexRoute: AuthGroupsIndexRoute,
  ErrorIndexRoute: ErrorIndexRoute,
  InstanceIndexRoute: InstanceIndexRoute,
  RoomManagementIndexRoute: RoomManagementIndexRoute,
  StatanalyticsIndexRoute: StatanalyticsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  AccountsRoomTypeRoute: AccountsRoomTypeRoute,
  RoomConfigRoomConfigNameRoute: RoomConfigRoomConfigNameRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName",
        "/room-management/$name",
        "/service-config/$configName",
        "/users/$id",
        "/auth-groups/",
        "/error/",
        "/instance/",
        "/room-management/",
        "/statanalytics/",
        "/users/",
        "/accounts/$room/$type",
        "/room-config/$room/$configName"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName": {
      "filePath": "aicon-config-toremove-cause-it-removed-from-separate-tab/$configName.tsx"
    },
    "/room-management/$name": {
      "filePath": "room-management/$name.tsx"
    },
    "/service-config/$configName": {
      "filePath": "service-config/$configName.tsx"
    },
    "/users/$id": {
      "filePath": "users/$id.tsx"
    },
    "/auth-groups/": {
      "filePath": "auth-groups/index.tsx"
    },
    "/error/": {
      "filePath": "error/index.tsx"
    },
    "/instance/": {
      "filePath": "instance/index.tsx"
    },
    "/room-management/": {
      "filePath": "room-management/index.tsx"
    },
    "/statanalytics/": {
      "filePath": "statanalytics/index.tsx"
    },
    "/users/": {
      "filePath": "users/index.tsx"
    },
    "/accounts/$room/$type": {
      "filePath": "accounts/$room.$type.tsx"
    },
    "/room-config/$room/$configName": {
      "filePath": "room-config/$room.$configName.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
